exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".FollowButton-0b78d5f5{width:80px;text-align:center}.normal-b0eed666{display:inline}.hover-e79befbe{display:none}.FollowButton-0b78d5f5:hover .hover-e79befbe{display:inline}.FollowButton-0b78d5f5:hover .normal-b0eed666{display:none}\n", ""]);

// Exports
exports.locals = {
	"FollowButton": "FollowButton-0b78d5f5",
	"normal": "normal-b0eed666",
	"hover": "hover-e79befbe"
};